import { Controller } from "@hotwired/stimulus"
import * as customizedTagify from '../helpers/customized_tagify.js';

export default class extends Controller {
  static targets = ["template", "itemsContainer"];

  addAssociation(event) {
    event.preventDefault();

    const isSingleRow = this.itemsContainerTarget.classList.contains('single_row');
    const numberOfChildren = this.itemsContainerTarget.children.length;
    let content = this.templateTarget.innerHTML.replace(/TEMPLATE_RECORD/g, new Date().valueOf());

    if (!isSingleRow || numberOfChildren === 0) {
      const insertionPromise = new Promise((resolve) => {
        const observer = new MutationObserver(() => {
          observer.disconnect();
          resolve();
        });

        observer.observe(this.itemsContainerTarget, { childList: true });
        this.itemsContainerTarget.insertAdjacentHTML('beforeend', content);
      });

      insertionPromise.then(() => {
        const fieldsToExpand = Array.from(document.getElementsByClassName('auto-expand'))
        if (fieldsToExpand.length > 0) {
          fieldsToExpand.forEach((field) => {
            var expandEvent = new Event('expand');
            field.dispatchEvent(expandEvent);
          });
        }
      });
    }

    if (isSingleRow && numberOfChildren > 0) return;

    const fields = this.itemsContainerTarget.querySelectorAll('.nested-fields');
    const lastField = fields[fields.length - 1];
    if (!lastField) return;

    lastField.querySelectorAll('input.tagify').forEach(function (field) {
      customizedTagify.makeTagifyForStepInput(field)
    });
  }

  removeAssociation(event) {
    event.preventDefault();
    let item = event.target.closest(".nested-fields");
    item.querySelector("input[name*='_destroy']").value = 1;
    item.style.display = 'none';
  }
}
